// src/data/physicsExperiments.js

const PHYSICS_EXPERIMENTS = {
  6: [
    {
      id: "magnet_attraction",
      title: "Magnetic Attraction & Repulsion",
      description:
        "Observe how like poles repel and unlike poles attract.",
    },
  ],

  7: [
    {
      id: "reflection_mirror",
      title: "Reflection of Light",
      description: "Demonstrate angle of incidence = angle of reflection.",
    },
  ],

  8: [
    {
      id: "sound_vibration",
      title: "Sound Produced by Vibrations",
      description: "Show that sound is produced by vibrating objects.",
    },
  ],

  9: [
    {
      id: "ohms_law",
      title: "Verification of Ohm’s Law",
      description:
        "Study the relationship between voltage and current in a circuit.",
    },
  ],

  10: [
    {
      id: "refraction_glass_slab",
      title: "Refraction Through Glass Slab",
      description:
        "Observe bending of light through a rectangular glass slab.",
    },
  ],
};

export default PHYSICS_EXPERIMENTS;
